import { render, staticRenderFns } from "./btn-get-phone-number.mpx?vue&type=template&id=6b04413e&isComponent&outputPath=components%2Fbtn-get-phone-number4af52718%2Findex"
import script from "./btn-get-phone-number.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-get-phone-number4af52718%2Findex"
export * from "./btn-get-phone-number.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-get-phone-number4af52718%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports